enum Indexes {
  Signs = 'Signs',
  PipeMarking = 'PipeMarking',
  Tags = 'Tags',
  AreaMarking = 'AreaMarking',
  Labels = 'Labels',
  BenchtopSystemsOther = 'BenchtopSystemsOther',
  Rfid = 'Rfid',
  Consumables = 'Consumables',
  Printers = 'Printers',
  GeneralSafety = 'GeneralSafety',
  LockoutTagout = 'LockoutTagout',
  Absorbents = 'Absorbents',
}

export default Indexes;
